const setUserConnection = (payload) => {
  //alert("User connection changed");
  return {
    type: "userconnectionChange",
    payload
  }
}
export default setUserConnection;
